import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons'
import { WheelManagementActionsConfirmModal } from './WheelManagementActionsConfirmModal'

export function SetActiveVersionAction({
  guildName,
  isHistorical = false,
  isActivating,
  onSetActive,
}: {
  guildName?: string
  isHistorical?: boolean
  isActivating: boolean
  onSetActive: () => void
}) {
  const [showConfirm, setShowConfirm] = useState(false)

  return (
    <>
      <button
        type="button"
        onClick={() => setShowConfirm(true)}
        disabled={isActivating}
        className="gw-version-bar__set-active-btn"
      >
        <FontAwesomeIcon icon={faCircleCheck} />
        {isActivating ? 'Activating…' : 'Set as Active'}
      </button>

      {showConfirm ? (
        <WheelManagementActionsConfirmModal
          tone="warning"
          confirmVariant="primary"
          title="Activate this version?"
          confirmLabel="Yes, Activate"
          irreversibleMessage=""
          onCancel={() => setShowConfirm(false)}
          onConfirm={() => {
            onSetActive()
            setShowConfirm(false)
          }}
        >
          <p className="gw-wm__hint">
            {isHistorical
              ? `This will restore this historical version as the active Growth Wheel${
                  guildName ? ` for ${guildName}` : ''
                }. The current active version will become historical. Contributors will see this version going forward. Evaluations on all versions are preserved.`
              : `Activating this version will replace the current active Growth Wheel${
                  guildName ? ` for ${guildName}` : ''
                }. Contributors will see this version going forward. Evaluations on the previous version are preserved.`}
          </p>
        </WheelManagementActionsConfirmModal>
      ) : null}
    </>
  )
}
